import { render, staticRenderFns } from "./LastOrdersItem.vue?vue&type=template&id=6744d719&"
import script from "./LastOrdersItem.vue?vue&type=script&lang=js&"
export * from "./LastOrdersItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6744d719')) {
      api.createRecord('6744d719', component.options)
    } else {
      api.reload('6744d719', component.options)
    }
    module.hot.accept("./LastOrdersItem.vue?vue&type=template&id=6744d719&", function () {
      api.rerender('6744d719', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/LastOrdersItem.vue"
export default component.exports